import { render, staticRenderFns } from "./admin-navbar.vue?vue&type=template&id=2395cfee&scoped=true&"
import script from "./admin-navbar.vue?vue&type=script&lang=js&"
export * from "./admin-navbar.vue?vue&type=script&lang=js&"
import style0 from "./admin-navbar.vue?vue&type=style&index=0&id=2395cfee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395cfee",
  null
  
)

export default component.exports